module.exports = __webpack_public_path__ + "img/yuanbao.b9926327.png";